import { Cookie } from '@nuxt-common/util/app/utils/cookie';

export const signedInUser = (cookies) => {
  try {
    const allCookies = Cookie.parse(cookies);
    let userName = null;
    let cookiesArray = [];
    const { SignedIn = '0', MISCGCs = '' } = allCookies;
    const isSoftSignedIn = () => userName && !SignedIn;
    if (MISCGCs) {
      cookiesArray = MISCGCs.split('3_87_');
      cookiesArray.forEach((cookie) => {
        if (cookie.includes('UserName')) {
          [, userName] = cookie.split('1_92_');
        }
      });
    }
    return SignedIn === '1' && !isSoftSignedIn();
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  let value1 = '';
  if (parts.length === 2) {
    value1 = parts.pop().split(';').shift();
  }
  let userData = '';
  if (value1) {
    const cookiesArray = value1.split('3_87_');
    cookiesArray.forEach((cookie) => {
      if (cookie.includes('UserName')) {
        const userName = cookie.split('1_92_');
        userData = userName[1];
      }
    });
    return userData;
  }

  return false;
};

export const getSEEDCookie = (cname) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
